import classNames from 'classnames'
import React from 'react'

import './Icon.css'

const Icon = ({ src, size, className, hoverable, onClick }) => {
   return (
      <img src={src} className={classNames("icon", {
         ["icon__" + size]: size,
         "icon__hoverable": hoverable
      }, className)} onClick={onClick} />
   )
}

export default Icon
